// @vendors
import React, { useContext, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';

// @components material
import {
  EditIcon,
  ExpandMoreRoundedIcon,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  Tooltip,
} from '../../../components/shared/MaterialUI';

// @assets
import { MenuProps } from '../../../assets/css/tableComponents-styles';
import { DashboardStyles } from '../../../assets/css/dashboard-style';
import { GeneralStyles } from '../../../assets/css/general-style';

// @context
import { useUI } from '../../../app/context/ui';

// @services
import OrganizationServiceNewApi from '../../../services/newApi/OrganizationService';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import { LISTROLES } from '../../../helpers/ListRoles';

// @components
import { Organization } from '../OrganizationScreen';
import AddNewOrganization from './AddNewOrganization';
import { theme } from '../../../assets/theme';

const OrganizationRow = ({row}) => {
  const generalStyle = useMemo(() => GeneralStyles(), []);
  const styleSelect = useMemo(() => DashboardStyles(), []);
  const { blockUI, snackbarUI } = useUI();
  const statusOptions = ["enable", "disable"];
  const organizationService = useMemo(() => new OrganizationServiceNewApi(), []);
  const {getListOrganization } = useContext(Organization);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const user = useSelector((state) => state.user);

  const onStatusChange = async (e) => {
      const OBJ = {
          name: row?.name,
          status: e.target.value,
          owner: row?.owner,
          infoEmail: row?.infoEmail,
          senderEmail: row?.senderEmail,
          homeUrl: row?.homeUrl
      }
      dataToUpdate(OBJ);
  };

  const dataToUpdate = async (obj) => {
    try {
        blockUI.current.open(true);
        await organizationService.updateOrganization(row?.id, obj);
        getListOrganization(true);
    } catch (e) {
        blockUI.current.open(false);
        AppHelper.checkError(e, snackbarUI);
    } 
  }

  const handleOpenModalEdit = () => {
    if(user?.role !== LISTROLES.superAdmin && row?.status !== 'enable')return snackbarUI.current.open('Editing inactive organizations is not allowed');
    setOpenModalEdit(true);
  }

  const permissionForEdit = () => {
    if(user?.role === LISTROLES.superAdmin || user?.role === LISTROLES.orgManager)return true;
    return false;
  }

  return (
    <>
      <TableRow>

        <TableCell
          scope="row"
          sx={{...generalStyle.tableCell, textAlign: 'left', paddingLeft: '30px'}}
        >
          {row.name}
        </TableCell>    
               
        <TableCell
          scope="row"
          sx={{
            ...generalStyle.tableCell,
            display: 'flex', 
            justifyContent: 'center'
          }}
        >
          <Select
            value={row.status}
            IconComponent={ExpandMoreRoundedIcon}
            onChange={(e) => onStatusChange(e)}
            sx={{
              ...styleSelect.statusSelect,
              pointerEvents: user?.role === LISTROLES.superAdmin ? 'auto' : 'none',
              width: {xs: '10rem', md: '15rem', lg: '15rem'},
            }}
            MenuProps={MenuProps}
          >
            {statusOptions.map((status, index) => (
              <MenuItem
                value={status}
                key={index}
                sx={{ textTransform: "capitalize" }}
              >
                {status}
              </MenuItem>
            ))}
          </Select>
        </TableCell>

        {permissionForEdit() &&
          <TableCell
            sx={{
              ...generalStyle.tableCell,
              ...generalStyle.tableColumnHide,
              padding: "0px 2.5em 0px 0px",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{display: 'flex', justifyContent: 'center'}}
            >
              <Tooltip
                title={<p style={{ fontSize: "16px", margin: "0" }}>Edit organization</p>}
                arrow
              >
                  <IconButton
                    onClick={() => handleOpenModalEdit()}
                    sx={{
                      color: theme.palette.secondary.black,
                      '&:hover': {
                        backgroundColor: theme.cards.iconBackground,
                        boxShadow: "none",
                      },
                    }}
                  >
                    <EditIcon sx={{ fontSize: "2rem" }} />
                  </IconButton>
              </Tooltip>
            </Grid>
          </TableCell>
        }      
      </TableRow>
      <AddNewOrganization
        open={openModalEdit}
        onClose={() => setOpenModalEdit(false)}
        isEdit={true}
        data={row}
      />
    </>
  )
}

export default OrganizationRow